import React, { useContext } from 'react';

import { defineMessages, FormattedMessage } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import Lozenge from '@atlaskit/lozenge';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { TeamInlinePreviewContext } from '../../store/context';

const styles = cssMap({
	lozengeWrapper: {
		display: 'flex',
		paddingLeft: token('space.050'),
	},
});

/**
 * Internal component that renders the "Archived" lozenge badge.
 * Conditionally wraps in Box based on preserveBadges setting for layout purposes.
 */
function ArchivedLozenge(): React.JSX.Element {
	const { preserveBadges, getTestId } = useContext(TeamInlinePreviewContext);

	const lozenge = (
		<Lozenge testId={getTestId('archived-lozenge')}>
			<FormattedMessage {...messages.archived} />
		</Lozenge>
	);

	return preserveBadges ? <Box xcss={styles.lozengeWrapper}>{lozenge}</Box> : lozenge;
}

const messages: {
	archived: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	archived: {
		id: 'team-inline.archived',
		defaultMessage: 'Archived',
		description: 'Label to indicate that a team is archived',
	},
});

export { ArchivedLozenge, messages };
